export enum LocationSearchResultType {
  ADDRESS = 'address',
  DFCI = 'dfci',
  DD = 'dd',
  DMS = 'dms',
}
